import { render, staticRenderFns } from "./treatments.vue?vue&type=template&id=d7261134&"
import script from "./treatments.vue?vue&type=script&lang=js&"
export * from "./treatments.vue?vue&type=script&lang=js&"
import style0 from "./treatments.vue?vue&type=style&index=0&id=d7261134&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports